

export default {
  name: `IconHourGlass`,
}
